<template>
  <div class="mark" ref="draggableMark" @click="onClick">
    <img :src="`${mark.image}`" class="mark__image" />
  </div>
</template>

<script>
import { initDraggable } from "../../utils";

export default {
  props: {
    mark: Object,
    draggable: Boolean,
    handleClick: Function
  },
  methods: {
    onClick() {
      if (this.handleClick) {
        this.handleClick();
      }
    }
  },
  mounted() {
    if (this.draggable) {
      const { draggableMark } = this.$refs;
      initDraggable(draggableMark, () => {
        console.log("dragging");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mark {
  width: 64px;
  height: 64px;
  margin: 7px;
  cursor: pointer;

  &__image {
    position: relative;
    z-index: 1;
    width: 64px;
    height: 64px;
    max-height: 64px;
    object-fit: contain;
  }
}
</style>

